<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-radio-group button-style="solid" v-model="filter.type" @change="getList">
          <a-radio-button value="dimension">
            维度
          </a-radio-button>
          <a-radio-button value="condition">
            条件
          </a-radio-button>
          <a-radio-button value="data">
            数据
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item v-if="filter.type==='data'">
        <a-select placeholder="数据分类" style="width: 150px;" v-model="filter.category" @change="getList" allowClear>
          <a-select-option :value="categoryIndex"
                           :key="'c'+categoryIndex"
                           v-for="(categoryItem,categoryIndex) in $store.state.report.dataCategory">
            {{categoryItem}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-input v-model="filter.name" @input="getList" placeholder="指标名称"></a-input>
      </a-form-item>
      <a-form-item style="float: right;margin-right: 0;">
        <a-button @click="()=>{addVisible=true;normInfo={};normInfo.type=filter.type;id=0}">添加</a-button>
      </a-form-item>
    </a-form>
    <a-table :columns="dataField" :data-source="dataList"
             style="background: #ffffff;"
             bordered :pagination="false">
      <template slot="type" slot-scope="text">{{typeList[text]}}</template>
      <template slot="category" slot-scope="text">{{$store.state.report.dataCategory[text]}}</template>
      <template slot="is_show" slot-scope="text,recode">
        <a>{{text?'显示':'隐藏'}}</a>
        <a @click="()=>{addVisible=true;normInfo=recode;id=recode.id}">编辑</a>
        <a style="color: #ff4d4f" @click="deleteNorm(recode.id)">删除</a>
      </template>
      <template slot="footer"  slot-scope="currentPageData">
        <a-pagination
          v-model="filter.page"
          style="text-align: right"
          show-size-changer
          :total="count"
          :page-size="filter.page_size"
          @change="changePage"
          @showSizeChange="changePage"
        />
      </template>
    </a-table>
    <a-modal
      :title="(id===0?'新增':'编辑')+'指标'"
      :visible="addVisible"
      @ok="doAddNorm()"
      @cancel="addVisible=false">
      <a-form-model :rules="normRules"
                    :model="normInfo"
                    v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 }}">
        <a-form-model-item label="指标名称" prop="name">
          <a-input v-model="normInfo.name" style="width: 200px;"/>
        </a-form-model-item>
        <a-form-model-item label="指标描述" prop="name">
          <a-input v-model="normInfo.desc" style="width: 200px;"/>
        </a-form-model-item>
        <a-form-model-item label="指标类型" prop="type">
          <a-radio-group button-style="solid" v-model="normInfo.type" @change="normInfo.category=''">
            <a-radio-button value="dimension">维度</a-radio-button>
            <a-radio-button value="condition">条件</a-radio-button>
            <a-radio-button value="data">数据</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="normInfo.type==='data'" label="指标分类" prop="category">
          <a-select v-model="normInfo.category">
            <a-select-option :value="categoryIndex"
                             :key="'c2'+categoryIndex"
                             v-for="(categoryItem,categoryIndex) in $store.state.report.dataCategory">
              {{categoryItem}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="指标编码" prop="code">
          <a-input v-model="normInfo.code" />
        </a-form-model-item>
        <a-form-model-item v-if="normInfo.category==='compose'" label="指标规则" prop="rule">
          <a-input v-model="normInfo.rule" />
        </a-form-model-item>
        <a-form-model-item v-if="id!==0" label="是否另存">
          <a-button @click="doCancelNorm">另存为</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {AddNorm, DeleteNorm, EditNorm, GetNormPage} from "../../api/v1/analysis";

export default {
  name: "Dictionaries",
  data(){
    return {
      id:0,
      typeList:{
        'dimension':'维度指标',
        'condition':'条件指标',
        'data':'数据指标'
      },
      filter:{
        type:'data',
        page:1,
        page_size:10,
      },
      dataField:[
        {title: '名称', dataIndex: 'name',},
        {title: '类型', dataIndex: 'type', scopedSlots: { customRender: 'type' }},
        {title: '编码', dataIndex: 'code',key:'code'},
        {title: '分类', dataIndex: 'category', scopedSlots: { customRender: 'category' }},
        {title: '规则', dataIndex: 'rule',},
        {title: '显示', dataIndex: 'is_show', scopedSlots: { customRender: 'is_show' }},
      ],
      dataList:[],
      count:0,
      addVisible:false,
      normRules:{},
      normInfo:{
        type:'data',
        category:'',
      },
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    changePage(page,page_size){
      this.filter.page = page
      this.filter.page_size = page_size
      this.getList()
    },
    getList(){
      GetNormPage(this.filter).then(resp => {
        if (resp.code===200){
          this.count = resp.data.count
          this.dataList = resp.data.list
          this.filter.page = resp.data.page
          this.filter.page_size = resp.data.page_size
        }
      })
    },
    deleteNorm(id){
      DeleteNorm({id:id}).then(resp => {
        if (resp.code===200){
          this.$message.success("删除成功")
          this.getList()
        }
      })
    },
    doCancelNorm(){
      this.id = 0
      this.doAddNorm()
    },
    doAddNorm(){
      if (this.id===0){
        AddNorm(this.normInfo).then(resp => {
          if (resp.code===200){
            this.$message.success("添加成功")
            this.filter.type = this.normInfo.type
            this.filter.page = 1
            this.getList()
            this.normInfo = {
              type:this.normInfo.type,
              category:'',
            }
            this.addVisible = false
          }
        })
      }else{
        EditNorm({id:this.id,form:this.normInfo}).then(resp => {
          if (resp.code===200){
            this.$message.success("编辑成功")
            this.getList()
            this.normInfo = {
              type:this.normInfo.type,
              category:'',
            }
            this.addVisible = false
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Report/Dictionaries.vue